import ReservationSegmentCardDispatcher from "../dispatcher/ReservationSegmentCardDispatcher";
import ReservationSegmentCardConstants from "../constants/ReservationSegmentCardConstants";

var ReservationSegmentCardActions = {
  /**
   * Initialize the CardStore
   *
   * @param {object} opts
   */

  init: function (opts) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.INIT,
      opts: opts,
    });
  },

  refresh: function (opts) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.REFRESH,
      opts: opts,
    });
  },

  save: function () {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.SAVE,
    });
  },

  // onActivateLocks: function (
  //   reservation_segment_device_accesses,
  //   remotelock_start_datetime_override,
  //   remotelock_end_datetime_override
  // ) {
  //   ReservationSegmentCardDispatcher.dispatch({
  //     action: ReservationSegmentCardConstants.ACTIVATE_LOCKS,
  //     reservation_segment_device_accesses: reservation_segment_device_accesses,
  //     remotelock_start_datetime_override: remotelock_start_datetime_override,
  //     remotelock_end_datetime_override: remotelock_end_datetime_override,
  //   });
  // },

  // onDeactivateLocks: function (reservation_segment_device_accesses) {
  //   ReservationSegmentCardDispatcher.dispatch({
  //     action: ReservationSegmentCardConstants.DEACTIVATE_LOCKS,
  //     reservation_segment_device_accesses: reservation_segment_device_accesses,
  //   });
  // },

  // onResetLocks: function () {
  //   ReservationSegmentCardDispatcher.dispatch({
  //     action: ReservationSegmentCardConstants.RESET_LOCKS,
  //   });
  // },

  onReactivateLocks: function (room_locks) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.REACTIVATE_LOCKS,
      room_locks: room_locks,
    });
  },

  setActiveTab: function (tab) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.SET_ACTIVE_TAB,
      tab: tab,
    });
  },

  setSubmitButton: function (submitButton) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.SET_SUBMIT_BUTTON,
      submitButton: submitButton,
    });
  },

  setValue: function (name, value) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.SET_VALUE,
      name: name,
      value: value,
    });
  },

  changeRoom: function (room) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHANGE_ROOM,
      room: room,
    });
  },

  changeCustomers: function (customers) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHANGE_CUSTOMERS,
      customers: customers,
    });
  },

  changeIncidentalDepositCard: function (incidental_deposit_card) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHANGE_INCIDENTAL_DEPOSIT_CARD,
      incidental_deposit_card: incidental_deposit_card,
    });
  },

  changeStatus: function (status) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHANGE_STATUS,
      status: status,
    });
  },

  changeRoomType: function (room_type) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHANGE_ROOM_TYPE,
      room_type: room_type,
    });
  },

  changeDates: function (check_in_date, check_out_date) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHANGE_DATES,
      check_in_date: check_in_date,
      check_out_date: check_out_date,
    });
  },

  editReservationSegment: function (room_type, check_in_date, check_out_date) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.EDIT_RESERVATION_SEGMENT,
      room_type: room_type,
      check_in_date: check_in_date,
      check_out_date: check_out_date,
    });
  },

  changePaymentCard: function (card_id) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHANGE_PAYMENT_CARD,
      card_id: card_id,
    });
  },

  changePaymentCustomer: function (customer) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHANGE_PAYMENT_CUSTOMER,
      customer_id: customer.id,
    });
  },

  changePaymentAmount: function (amount) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHANGE_PAYMENT_AMOUNT,
      amount: amount,
    });
  },

  changePaymentType: function (type) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHANGE_PAYMENT_TYPE,
      payment_type: type,
    });
  },

  // changePaymentEvent: function(event) {
  //   ReservationSegmentCardDispatcher.dispatch({
  //     action: ReservationSegmentCardConstants.CHANGE_PAYMENT_EVENT,
  //     event: event,
  //   })
  // },

  applyPromotion: function (data, reservation_segment) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.APPLY_PROMOTION,
      reservation: data,
      reservation_segment: reservation_segment,
    });
  },

  applyDiscount: function (data, reservation_segment) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.APPLY_DISCOUNT,
      reservation: data,
      reservation_segment: reservation_segment,
    });
  },

  removePromotion: function () {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.REMOVE_PROMOTION,
    });
  },

  changeGuests: function (number) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHANGE_GUESTS,
      number_of_guests: number,
    });
  },

  changeNotes: function (notes) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHANGE_NOTES,
      notes: notes,
    });
  },

  changeRate: function (rate_id) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHANGE_RATE,
      rate_id: rate_id,
    });
  },

  checkIn: function () {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.CHECK_IN,
    });
  },

  updateNoteCount: function (count) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.UPDATE_NOTE_COUNT,
      count: count,
    });
  },

  updateServiceRequestCount: function (count) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.UPDATE_SERVICE_REQUEST_COUNT,
      count: count,
    });
  },

  updateClosedCount: function (count) {
    ReservationSegmentCardDispatcher.dispatch({
      action: ReservationSegmentCardConstants.UPDATE_CLOSED_COUNT,
      count: count,
    });
  },
};

export default ReservationSegmentCardActions;
